<template>
  <div id="admin_rpts_advert_views_rpt">
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Report Filter"
      id="admin_advert_views_report_filter"
    ></CardedSectionHeader>
    <CardedForm
      ref="admin_advert_views_report_filter_form_ref"
      id="admin_advert_views_report_filter_form_form"
      title="You can filter by: Start date, End date, and advert_id"
      :is_loading="is_loading"
      @on-submit-form="filter_report"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      cmp_class="ma-0 pl-5 pr-5 pt-0 white"
      @on-clear-form="on_clear_form"
    >
      <v-row no-gutterss class="pa-0 mb-0" :key="date_input_key">
        <v-col class="pt-0 pb-0 mb-0">
          <DateField
            label="Start Date"
            v-model="form.start_date_display"
            :disabled="is_loading"
            :validation_rules="form_validations.start_date_display"
            :min="'2018-01-01'"
            :max="form.date_today"
          ></DateField>
        </v-col>
        <v-col class="pt-0 pb-0 mb-0">
          <DateField
            label="End Date"
            v-model="form.end_date_display"
            :disabled="is_loading"
            :validation_rules="form_validations.end_date_display"
            :min="form.start_date_display"
            :max="form.date_today"
          ></DateField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.advert_id"
            :validation_rules="form_validations.advert_id"
            label="Advert ID (returns clicks for a specific advert)"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>
    </CardedForm>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Report Table"
      id="admin_advert_views_report_table"
    ></CardedSectionHeader>
    <CardedTable
      :items="items"
      :headers="headers"
      :show_search="true"
      :show_description="false"
      :show_header_bar="true"
      :has_margin="false"
    >
      <template v-slot:controls>
        <div>
          <h4 class="pt-3">{{ report_message }}</h4>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedTable from "../../../components/CardedTable";
import CardedForm from "../../../components/CardedForm";
import DateField from "../../../components/DateField";
import TextField from "../../../components/TextField";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminReportsAdvertClicks",
  components: {
    CardedSectionHeader,
    DateField,
    CardedTable,
    CardedForm,
    TextField
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      errors: [],
      message: "",
      form: {
        start_date_display: Utils.get_today_date_str(),
        end_date_display: Utils.get_today_date_str(),
        advert_id: "",
      },
      form_validations: {
        start_date_display: [],
        end_date_display: [],
        advert_id: [
          Utils.validate.if_provided_numeric("advert Id must be a whole digit number e.g 5, 10, 40, 7, 160 "),
          Utils.validate.if_provided_min_max(1, 1000000, "advert Ids range from 1 to 1000000 ")
        ],
      },
      items: [],
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: true,
          value: "id",
          filterable: true,
        },
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "advert.title",
          filterable: true,
        },
        {
          text: "Platform",
          align: "start",
          sortable: true,
          value: "advert.platform",
          filterable: true,
        },
        {
          text: "Date",
          align: "center",
          sortable: true,
          value: "clicked_on",
          filterable: true,
        },
        {
          text: "Page",
          align: "center",
          sortable: true,
          value: "page",
          filterable: true,
        },
        {
          text: "Section",
          align: "start",
          sortable: true,
          value: "section",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      report_message: "",
      date_input_key: "views_advert_date_inputs_key_1",
      date_input_key_truck: 1,
    };
  },
  methods: {
    on_clear_form() {
      this.form.start_date_display = Utils.get_today_date_str();
      this.form.end_date_display = Utils.get_today_date_str();
      this.form.advert_id = "";
      this.date_input_key_truck = this.date_input_key_truck + 1;
      this.date_input_key =
        "views_advert_date_inputs_key_" + this.date_input_key_truck;
    },
    on_auto_fill() {
      this.refresh_table();
    },
    filter_report() {
      this.refresh_table();
    },
    load_items(filter_config) {
      this.$emit("on-show-loader");
      ServerClient.Reports.get_clicks_adverts_report(
        {
          ...filter_config,
        },
        (res) => {
          this.items = res;

          this.process_report_message();
          this.$emit("on-hide-loader");
          var options = {
            offset: 50,
            duration: 1000,
            easing: "easeInOutCubic",
          };
          this.$vuetify.goTo("#admin_advert_views_report_table", options);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.admin_advert_views_report_filter_form_ref.show_error_dialog();
        }
      );
    },
    refresh_table() {
      this.errors = [];
      var start_time_str = this.form.start_date_display + " 00:30:00 AM ";
      var start_time = Utils.date_str_to_php_time(start_time_str);
      var end_time_str = this.form.end_date_display + " 11:30:00 PM ";
      var end_time = Utils.date_str_to_php_time(end_time_str);
      if (start_time == end_time) {
        this.errors.push("Start time cannot be equal to end time");
        this.$refs.admin_advert_views_report_filter_form_ref.show_error_dialog();
        return false;
      }
      if (start_time > end_time) {
        this.errors.push("Start time cannot be greater than end time");
        this.$refs.admin_advert_views_report_filter_form_ref.show_error_dialog();
        return false;
      }

      this.load_items({
        ...this.form,
      });
    },
    process_report_message() {
      var num_str = "";
      if (this.items.length == 0) {
        num_str = " were no advert clicks ";
      } else if (this.items.length == 1) {
        num_str = " was only (1) one advert clicks ";
      } else if (this.items.length > 1) {
        num_str = " were " + this.items.length + "  advert clicks ";
      }

      var start_word = Utils.date_str_to_words(
        this.form.start_date_display,
        true,
        "of"
      );
      var end_word = Utils.date_str_to_words(
        this.form.end_date_display,
        true,
        "of"
      );
      var msg = "";
      if (this.form.start_date_display == this.form.end_date_display) {
        msg = "There " + num_str + " on the " + start_word;
      } else {
        msg =
          "There " +
          num_str +
          " between the " +
          start_word +
          " and the " +
          end_word;
      }
      this.report_message = msg;
    },
    on_view_item(item) {
      this.$router.push("/admin/adverts/list/view/" + item.advert_id);
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if is not admin please redirect this user to the login screen

    this.$emit("set-page-attributes", {
      title: "Adverts Clicks Report",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Reports",
          disabled: false,
          href: "/admin/reports",
        },
        {
          text: "Ad Clicks",
          disabled: true,
          href: "/admin/reports/adverts",
        },
      ],
    });

    this.refresh_table();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_rpts_advert_views_rpt", options);
  },
};
</script>